const allLanguages = [
  { name: 'EN', code: 'en' },
  { name: 'DE', code: 'de' },
  { name: 'ES', code: 'es' },
  { name: 'IT', code: 'it' },
  { name: 'PL', code: 'pl' },
  { name: 'JP', code: 'jp' },
  { name: 'CN', code: 'cn' },
]

const envLangs = process.env.REACT_APP_AVAILABLE_LANGUAGES

const languages = envLangs
  ? allLanguages.filter((lang) =>
      envLangs
        .split(',')
        .map((code) => code.trim().toLowerCase())
        .includes(lang.code)
    )
  : allLanguages

export default languages
